export default {
  // api: "http://localhost:3000/api/v1",
  api: "https://api.airshuttle.flights/api/v1",
  version: "2.0.0",
  userKey: "@aerorio/user",
  tokenKey: "@aerorio/token",
};



// WEBPACK FOOTER //
// ./src/config/constants.js